'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.sendActivityLogWidget = function (activityLog) {
	return mmWidgets.each(this, function () {
		const widget = this.domElements[0];
		widget.addEventListener('click', () => {
			const logMessage = btoa(JSON.stringify(activityLog.getLog()));
			widget.setAttribute('href', 'mailto:gold-support@mindmup.com?subject=error&body=' + logMessage);
		});
	});
};
